/* eslint-disable consistent-return */
/* eslint-disable no-alert */
import React, { memo, useCallback, useEffect, useMemo, useState } from "react";

import {
  DoubleRightOutlined,
  FilePdfOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import {
  Dropdown,
  Menu,
  Tooltip,
  Modal,
  DatePicker,
  ConfigProvider,
  Popover,
  Select,
  Checkbox,
} from "antd";
import datePickerLocale from "antd/lib/locale/pt_BR";
import { ErrorMessage, Field, Form, Formik } from "formik";
import moment from "moment";
import useInView from "react-cool-inview";
import { AiOutlineClose, AiOutlineFilePdf } from "react-icons/ai";
import { BiMenu } from "react-icons/bi";
import { CiCreditCard1 } from "react-icons/ci";
import {
  FaAngleLeft,
  FaAngleRight,
  FaFilter,
  FaRegBuilding,
  FaRegCalendarAlt,
  FaSortDown,
} from "react-icons/fa";
import { FiAlertTriangle, FiEye } from "react-icons/fi";
import { MdOutlineSend } from "react-icons/md";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import ReactInputMask from "react-input-mask";
import Slider from "react-slick";
import * as Yup from "yup";

import FileIcon from "../../../assets/FileIcon";
import Can from "../../../components/Can";
import { DuplicatedInvoicePDFModal } from "../../../components/DuplicatedInvoicePDFModal";
import LoadingElevaty from "../../../components/LoadingElevaty";
import ModalBlockedPopUp from "../../../components/ModalBlockedPopup";
import ModalHistoricoFaturas from "../../../components/ModalHistoricoFaturas";
import { usePermissions } from "../../../Context/permissionContext";
import { useAuth } from "../../../hooks/AuthProvider";
import { useClient } from "../../../hooks/ClientProvider";
import useFutureInvoices from "../../../hooks/useFutureInvoices";
import useInvoicev2 from "../../../hooks/useInvoicev2";
import useToggle from "../../../hooks/useToggle";
import api from "../../../services/api";
import { formatDate, formatCalendarDay } from "../../../utils/formatDate";
import { formatPhone } from "../../../utils/formatPhone";
import { getInvoicePdf } from "../../../utils/get-invoice-pdf";
import { notifyError, notifySucces } from "../../../utils/notifications";
import { obterNomeDoMes } from "../../../utils/obterNomeDoMes";
import InvoiceInstallmentAnticipationModal from "../../home/Invoice/modals/installmentAnticipation";
import InstallmentsViewModal from "../../home/Invoice/modals/InstallmentsView";
import ModalChangeInvoiceDueDate from "../../home/modals/modalChangeInvoiceDueDate";
import * as Style from "./style";
import ModalListAllLaunches from "./components/ModalListAllLaunches";
import AntecipateSalesModal from "./AntecipateSales/AntecipateSalesModal";
import { InvoiceInstallmentSimulatorFlow } from "../../../components-v2/InvoiceInstallmentSimulatorFlow";
import { hasProcessorPermission } from "../../../helpers/hasProcessorPermission";
import {
  INVOICE_DUE_DATE_PUSH_DESCRIPTION,
  INVOICE_DUE_DATE_PUSH_JOURNEY,
  INVOICE_DUE_DATE_PUSH_LABEL,
  INVOICE_DUE_DATE_PUSH_SUCCESS,
  INVOICE_DUE_DATE_PUSH_TITLE,
  INVOICE_DUE_DATE_SAC_LABEL,
  resolveInvoiceDueDateActionVisibility,
} from "../../../helpers/getInvoiceDueDateActionVisibility";

const { Item } = Menu;
const { RangePicker } = DatePicker;
const { Option } = Select;

function FaturaV2() {
  const { permissions } = usePermissions();
  const { client, refreshCardFinancial,refreshClientV2 } = useClient();
  const { user } = useAuth();
  const [isChangeInvoiceDueDateVisible, setIsChangeInvoiceDueDateVisible] =
    useState(false);
  const [dateCiclos, setDateCiclos] = useState([]);
  const [cicloValue] = useState("0");
  const [filterRangeActive, setFilterRangeActive] = useState(false);

  const [modalHistoricoFaturas, setModalHistoricoFaturas] = useState(false);

  const [lastYear, setLastYear] = useState(() => {
    const lastYearDate = new Date();
    lastYearDate.setMonth(lastYearDate.getMonth() + 2);
    lastYearDate.setDate(0);
    lastYearDate.setMonth(lastYearDate.getMonth() - 12);
    return lastYearDate;
  });
  const [today, setToday] = useState(() => {
    const todayDate = new Date();
    todayDate.setMonth(todayDate.getMonth() + 2);
    todayDate.setDate(0);
    return todayDate;
  });
  const [isModalFaturaOpen, setIsModalFaturaOpen] = useState(false);
  const [isModalLancamentosOpen, setIsModalLancamentosOpen] = useState(false);
  const [typeFature, setTypeFature] = useState("email");
  const typeSendFature = "fatura";
  const [loadingFature, setLoadingFature] = useState(true);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [codBarras, setCodBarras] = useState(false);
  const [faturaSelected, setFaturaSelected] = useState(null);
  const [valueEmailDownload, setValueEmailDownload] = useState("");
  const [disabledInputEmail, setDisabledInputEmail] = useState(false);
  const [valueFormInputSMS, setValueFormInputSMS] = useState("");
  const [disabledInputSMS, setDisabledInputSMS] = useState(false);
  const [disabledInput, setDisabledInput] = useState(false);
  const [disabledInputSelectSMS, setDisabledInputSelectSMS] = useState(false);
  const [loadingTable, setLoadingTable] = useState(true);
  const [infosFullFatura, setInfosFullFatura] = useState();
  const [rangeDate, setRangeDate] = useState(false);
  const [indexCarouselInitial, setIndexCarouselInitial] = useState();
  const [phones, setPhones] = useState([]);
  const [loadingInvoicePdf, setLoadingInvoicePdf] = useState(false);
  const [carouselInvoices, setCarouselInvoices] = useState();
  const [modalPopUp, setModalPopUp] = useState(false);
  const [loadingInvoiceIdPdf, setLoadingInvoiceIdPdf] = useState(undefined);
  const [openAntecipateSalesModal, setOpenAntecipateSalesModal] =
    useState(false);
  const [forceUpdateScreen, setForceUpdateScreen] = useState(false);

  const savedData = sessionStorage.getItem("@SAC_RPE_PERMISSION_MANAGEMENT");

  const permissionManagement = savedData
    ? JSON.parse(savedData)
    : { currentProcessor: undefined, apiData: [] };

  const handleUpdateScreen = () => {
    setForceUpdateScreen((prev) => !prev);

    if (refreshCardFinancial) {
      refreshCardFinancial();
    }
  };

  const handleShowPopUpModal = () => {
    setModalPopUp((prev) => !prev);
  };

  const showChangeInvoiceDueDate = useCallback(() => {
    setIsChangeInvoiceDueDateVisible(true);
  }, []);

  const handleSendDueDatePush = useCallback(async () => {
    const cpf = client?.client?.cpf;
    if (!cpf) {
      notifyError("CPF do portador não encontrado");
      return;
    }

    try {
      const response = await api.post("push-api/notificacoes", {
        jornada: INVOICE_DUE_DATE_PUSH_JOURNEY,
        cpf,
        client_id: client?.client?.id,
        titulo: INVOICE_DUE_DATE_PUSH_TITLE,
        descricao: INVOICE_DUE_DATE_PUSH_DESCRIPTION,
      });

      const statusCode = Number(response?.statusCode);
      if (Number.isFinite(statusCode) && statusCode !== 200) {
        notifyError(
          response?.detail ||
            response?.message ||
            "Falha ao enviar link de alteração de vencimento"
        );
        return;
      }

      notifySucces(INVOICE_DUE_DATE_PUSH_SUCCESS);
      if (refreshClientV2) await refreshClientV2();
    } catch (error) {
      notifyError(
        error?.message || "Falha ao enviar link de alteração de vencimento"
      );
    }
  }, [client, refreshClientV2]);

  const {
    invoices,
    loadingInvoice,
    getData: reloadInvoices,
  } = useInvoicev2(
    client?.client?.id,
    formatCalendarDay(lastYear),
    formatCalendarDay(today),
    forceUpdateScreen
  );

  const lastInvoiceHasAssociatedPayments = useCallback(
    // eslint-disable-next-line func-names
    function () {
      if (invoices.length > 0) {
        const lastInvoiceData = invoices[invoices.length - 1];
        const associatedPaymentTotalValue = parseFloat(
          lastInvoiceData?.valorPagamentosEfetuados?.replace("R$ ", "")
        );

        if (
          associatedPaymentTotalValue === 0 ||
          isNaN(associatedPaymentTotalValue) ||
          associatedPaymentTotalValue === undefined
        ) {
          return false;
        }
        return true;
      }
    },
    [invoices]
  );

  const { futureInvoices, getData: reloadFutureInvoices } = useFutureInvoices(
    client?.client?.id,
    forceUpdateScreen
  );

  const removeMonetaryFormation = (string) =>
    Number(string?.replace("R$ ", ""));

  const isInvoiceNull = useMemo(() => {
    if (invoices === undefined) {
      return true;
    }
    if (invoices.length === 0) {
      return true;
    }

    if (invoices?.length > 0) {
      return (
        removeMonetaryFormation(invoices?.[invoices.length - 1]?.devedor) === 0
      );
    }
  }, [invoices]);

  const [
    isModalInstallmentSimulationVisible,
    setIsModalInstallmentSimulationVisibility,
  ] = useToggle();

  const [isModalDebitBalanceVisible, toggleModalDebitBalanceVisibility] =
    useToggle();

  const [isModalInstallmentsViewVisible, setIsModalInstallmentsViewVisibility] =
    useToggle();

  const isDebitInstallmentDisabled = useMemo(() => {
    const { devedorTotal } = client.client;
    return devedorTotal <= 0;
  }, [client]);

  const handleInvoiceActionsClick = useCallback(
    ({ key }) => {
      if (key === "alterar-vencimento-push") {
        handleSendDueDatePush();
      }
    },
    [handleSendDueDatePush]
  );

  const { showSacDueDateAction, showPushDueDateAction } = useMemo(
    () => resolveInvoiceDueDateActionVisibility(permissions),
    [permissions]
  );

  const menuInsurance = useMemo(
    () => (
      <Menu onClick={handleInvoiceActionsClick}>
        {showSacDueDateAction && (
          <Item
            key="alterar-vencimento-sac"
            onClick={showChangeInvoiceDueDate}
            data-testid="faturav2-alterar-vencimento-sac"
          >
            <Style.ListItemText>{INVOICE_DUE_DATE_SAC_LABEL}</Style.ListItemText>
          </Item>
        )}

        {showPushDueDateAction && (
          <Item
            key="alterar-vencimento-push"
            data-testid="faturav2-alterar-vencimento-push"
          >
            <Style.ListItemText>
              {INVOICE_DUE_DATE_PUSH_LABEL}
            </Style.ListItemText>
          </Item>
        )}

        {permissions?.includes("invoice_installment") && (
          <Item
            key="1"
            onClick={setIsModalInstallmentSimulationVisibility}
            disabled={isInvoiceNull || lastInvoiceHasAssociatedPayments()}
          >
            <Tooltip
              title={
                isInvoiceNull
                  ? "Usuário não possui saldo devedor para a última fatura"
                  : lastInvoiceHasAssociatedPayments()
                  ? "Usuário possui pagamento associado à fatura ativa"
                  : "Simular parcelamento da fatura"
              }
            >
              <Style.ListItemText>
                Simular parcelamento da fatura
              </Style.ListItemText>
            </Tooltip>
          </Item>
        )}

        {permissions?.includes("debtor_installment") && (
          <Item
            key="2"
            onClick={toggleModalDebitBalanceVisibility}
            disabled={isDebitInstallmentDisabled}
          >
            <Tooltip
              title={
                isDebitInstallmentDisabled &&
                "Cliente não possui devedor futuro"
              }
            >
              <Style.ListItemText>
                Simular parcelamento de saldo devedor total
              </Style.ListItemText>
            </Tooltip>
          </Item>
        )}
        {permissions?.includes("permission_view_invoice_installments") && (
          <Item key="3" onClick={setIsModalInstallmentsViewVisibility}>
            <Style.ListItemText>
              Visualizar parcelamento da fatura / saldo devedor
            </Style.ListItemText>
          </Item>
        )}
        {permissions?.includes("active_installment") && (
          <InvoiceInstallmentAnticipationModal key={4} />
        )}

        <Item key="5" onClick={() => setModalHistoricoFaturas(true)}>
          <Style.ListItemText>Histórico de faturas</Style.ListItemText>
        </Item>

        {hasProcessorPermission(
          "antecipateSales",
          permissionManagement?.currentProcessor
        ) && (
          <>
            {permissions.includes("permission_antecipate_sales") && (
              <Item
                key="6"
                onClick={() => setOpenAntecipateSalesModal(true)}
                data-test-id="btn-antecipar-vendas"
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "1rem",
                  }}
                >
                  <Style.ListItemText
                    style={{
                      fontWeight: 500,
                      fontFamily: "Ubuntu",
                    }}
                  >
                    Antecipação de Vendas
                  </Style.ListItemText>
                </div>
              </Item>
            )}
          </>
        )}
      </Menu>
    ),
    [
      permissions,
      showChangeInvoiceDueDate,
      handleSendDueDatePush,
      handleInvoiceActionsClick,
      showSacDueDateAction,
      showPushDueDateAction,
      isInvoiceNull,
    ]
  );

  const fetchCycles = useCallback(async () => {
    try {
      const resp = await api.get("ciclos_details");
      const { data } = resp;
      const filteredDates = data.filter((c) => c.ativo === "S");
      const sortedArray = filteredDates.sort(
        (a, b) => a.diaVencimento - b.diaVencimento
      );

      setDateCiclos(sortedArray);
    } catch (error) {
      console.error("Falha ao listar ciclos disponiveis para cliente");
    }
  }, []);

  const { observe } = useInView({
    threshold: 0.1,
    onEnter: ({ unobserve }) => {
      fetchCycles().then(unobserve);
    },
  });

  // eslint-disable-next-line react/no-unstable-nested-components
  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div className={className} style={{ ...style }} onClick={onClick}>
        <FaAngleRight />
      </div>
    );
  }

  // eslint-disable-next-line react/no-unstable-nested-components
  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div className={className} style={{ ...style }} onClick={onClick}>
        <FaAngleLeft />
      </div>
    );
  }

  const settings = {
    dots: false,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    initialSlide: indexCarouselInitial ?? 0,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const getDataInvoicesDetailV2 = async (invoiceID) => {
    try {
      const response = await api.get("client_detailed_invoice", {
        client_id: client.client.id,
        invoice_id: invoiceID,
      });

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      let paymentData = "";

      const extractLiteralDate = (isoString) => {
        if (!isoString) return "";
        const datePart = isoString.split("T")[0]; 
        const [year, month, day] = datePart.split("-"); 
        return `${day}/${month}/${year}`;
      };

      const formatedDate = response.data.lancamentos.map((item) => {
        item.dataLancamento = extractLiteralDate(item.dataLancamento);
        item.dataTransacao = extractLiteralDate(item.dataTransacao);
        item.valor = `R$ ${Number(item.valor).toFixed(2)}`;
        if (item.tipo === "PAGAMENTO") {
          paymentData = item.dataLancamento;
        }
        return item;
      });

      response.data.lancamentos = formatedDate;

      setInfosFullFatura(response.data);

      setTimeout(() => {
        setLoadingTable(false);
      }, 1000);
      return response.data;
    } catch (e) {
      notifyError("Erro em faturas");
    }
  };

  const onGetInvoicePdf = useCallback(
    async (invoiceId, due_date, cpf) => {
      await getInvoicePdf({
        invoiceId,
        initLoadingState: () => setLoadingInvoiceIdPdf(invoiceId),
        finishLoadingState: () => setLoadingInvoiceIdPdf(undefined),
        clientId: client.client.id,
        due_date,
        cpf,
        handleShowPopUpModal,
      });
    },
    [client]
  );

  const handleSelectFatura = useCallback((value) => {
    if (value?.future) {
      setFaturaSelected(value);
      setLoadingTable(true);
      setInfosFullFatura(value);

      setTimeout(() => {
        setLoadingTable(false);
      }, 1000);
    } else {
      setFaturaSelected(value);
      setLoadingTable(true);
      getDataInvoicesDetailV2(value.idFatura);
    }
  }, []);

  const changeRangeFatura = (e) => {
    setLastYear(moment(e[0].utc().format("YYYY-MM-DD HH:mm:ss")).toDate());
    setToday(moment(e[1].utc().format("YYYY-MM-DD HH:mm:ss")).toDate());
    setFilterRangeActive(true);
  };

  const getPhonesUser = () => {
    api
      .get("client_contacts", { client_id: client.client.id })
      .then((response) => {
        const numberSms = response.data.filter((cel) => cel.tipo === "CELULAR");
        const formattedPhones = Array.isArray(numberSms)
          ? numberSms.map((number) => formatPhone(number?.area, number?.numero))
          : numberSms;
        setPhones(formattedPhones);
      });
  };

  const getClosedInvoice = useCallback(
    async (row) => {
      setIsModalFaturaOpen(true);
      setTypeFature("email");
      getPhonesUser();
      try {
        const {
          data: {
            linhaDigitavel,
            linhaDigitavelFormatada,
            hashFatura,
            lancamentos,
            dataVencimento,
          },
        } = await api.get("client_closed_invoice", {
          client_id: client.client.id,
          billet_id: row.idFatura,
        });
        setSelectedInvoice({
          ...row,
          hashFatura,
          lancamentos,
          dataVencimento,
        });
        setCodBarras(linhaDigitavel ?? linhaDigitavelFormatada);
        setLoadingFature(false);
      } catch (error) {
        const textoErro = "Falha ao carregar linha digitável";

        setIsModalFaturaOpen(false);
        const stringError = error.message;
        // Verifica se a string contém a palavra "detail"
        if (stringError.includes("detail")) {
          const splitArray = stringError.split("detail:");
          const detailText = splitArray[1].split(",")[0].trim();
          if (detailText) {
            notifyError(detailText);
            throw new Error(textoErro);
          } else {
            notifyError(textoErro);
          }
        }
        throw new Error(notifyError(error.message));
      }
    },
    [client]
  );

  const handleChangeModalEmailInput = (event, setFieldValue) => {
    setDisabledInput(true);
    const { value } = event.target;
    setFieldValue("customEmail", value);
    setValueEmailDownload(value);
  };

  const handleChangeModalSMSlInput = (event, setFieldValue) => {
    setDisabledInputSelectSMS(true);
    const { value } = event.target;
    setFieldValue("customPhone", value);
    setValueFormInputSMS(value);
  };

  const handleSelectMail = (event, setFieldValue) => {
    // eslint-disable-next-line eqeqeq
    if (event == 0) {
      setFieldValue("email", "");
    } else {
      setFieldValue("email", event);
    }
  };

  const handleSelectSMS = (event, setFieldValue) => {
    // eslint-disable-next-line eqeqeq
    if (event == 0) {
      setFieldValue("phone", "");
    } else {
      setFieldValue("phone", event);
    }
  };

  const handleChangeSendToUnregisteredMail = (checked, setFieldValue) => {
    setFieldValue("sendToUnregisteredMail", checked);
    setDisabledInput(checked);
    setDisabledInputEmail(!checked);
  };

  const handleChangeSendToUnregisteredSMS = (checked, setFieldValue) => {
    setFieldValue("sendToUnregisteredPhone", checked);
    setDisabledInputSelectSMS(checked);
    setDisabledInputSMS(!checked);
  };

  const handleReloadInvoices = () => {
    reloadInvoices();
    reloadFutureInvoices();
  };

  useEffect(() => {
    if (invoices) {
      const filteredData = invoices.filter((item) => item.status === "ATUAL");

      if (filterRangeActive) {
        setCarouselInvoices(invoices);

        const lastIndex = invoices.length - 1;

        setIndexCarouselInitial(lastIndex - 2);

        if (invoices[0]?.idFatura) {
          setFaturaSelected(invoices[0]);
          getDataInvoicesDetailV2(invoices[0].idFatura);
        } else {
          setFaturaSelected(false);
          getDataInvoicesDetailV2(null);
          setInfosFullFatura(null);
        }

        setTimeout(() => {
          setLoadingTable(false);
        }, 1000);
        return;
      }

      if (futureInvoices) {
        const editFutureInvoices = futureInvoices.map((item, index) => {
          const brV = formatDate(item.dataVencimento);
          const brC = formatDate(item.dataCorte);
          const splitDate = brV.split("/");

          const formatedLancamentos = item?.lancamentos.map((l) => ({
            tipo: l.tipo,
            descricaoLancamento: l.descricaoLancamento,
            dataLancamento: formatDate(l.dataLancamento),
            dataTransacao: formatDate(l.dataTransacao),
            valor: `R$ ${Number(l.valor).toFixed(2)}`,
          }));

          return {
            idFatura: `${index}-future`,
            dataVencimento: brV,
            dataCorte: brC,
            anoVencimento: splitDate[2]?.slice(-2),
            MesVencimento: obterNomeDoMes(parseInt(splitDate[1], 10)),
            DataVencimentoOnly: splitDate[0],
            valorTotal: `R$ ${Number(item.valor).toFixed(2)}`,
            lancamentos: [...formatedLancamentos],
            future: true,
          };
        });

        setCarouselInvoices([...invoices, ...editFutureInvoices]);

        const lastIndex = invoices.length - 1;

        setIndexCarouselInitial(lastIndex - 2);

        if (filteredData[0]?.idFatura) {
          setFaturaSelected(filteredData[0]);
          getDataInvoicesDetailV2(filteredData[0].idFatura);
        }

        setTimeout(() => {
          setLoadingTable(false);
        }, 1000);

        return false;
      }

      if (filteredData[0]?.idFatura) {
        setFaturaSelected(filteredData[0]);
        getDataInvoicesDetailV2(filteredData[0].idFatura);
      }
    }
  }, [invoices, futureInvoices, filterRangeActive, forceUpdateScreen]);

  // ENVIO FATURA E-MAIL

  const closeModalSendFaturas = () => {
    setIsModalFaturaOpen(false);
    setLoadingFature(true);
    setTypeFature("email");
    setValueEmailDownload("");
    setDisabledInput(false);
    setDisabledInputEmail(false);
  };

  const companyId = user?.company_id;

  const sendMail = useCallback(async (email, faturaDetails, codigoBarras) => {
    const identity = localStorage.getItem("@SacRPE:identity");
    setLoadingFature(true);
    try {
      await api.post("send_mail_barCode", {
        firstName: client.client.name,
        nameCard: client.client.name,
        cpfCnpj: client.client.cpf,
        cardNumber: client.client.numeroCartaoTruncado,
        clientId: client.client.id,
        expiryDate: faturaDetails?.dataVencimento,
        totalValue:
          faturaDetails?.valorTotal ?? faturaDetails?.valorTotalFaturaAtual,
        minimumValue:
          faturaDetails?.valorMinimo ??
          faturaDetails?.valorPagamentoMinimoFaturaAtual,
        linhaDigitavel: codigoBarras || "",
        hashFatura: faturaDetails?.hashFatura,
        invoiceId: faturaDetails?.idFatura,
        identity,
        companyId,
        ticket: client.client.ticket.protocol,
        email,
        lancamentos: faturaDetails?.lancamentos,
        productCode: client.product.codigoProduto,
        productName: client.product.desc_prod,
        status: faturaDetails?.status,
      });
      notifySucces(`Sucesso ao enviar email para ${email}`);
      closeModalSendFaturas();
    } catch (error) {
      notifyError(`Falha ao enviar email para ${email}`);
      console.error(`Falha ao enviar email para ${email}`, error.message);
      closeModalSendFaturas();
    }
  }, []);

  const handleSendEmailFatura = useCallback(
    (valueEmail) => {
      const { email, customEmail, sendToUnregisteredMail } = valueEmail;

      const mail = sendToUnregisteredMail ? customEmail : email;

      if (typeSendFature === "fatura") {
        sendMail(mail, selectedInvoice, codBarras);
      } else {
        alert("FATURA E BOLETO");
      }
    },
    [selectedInvoice, typeSendFature, codBarras]
  );

  const showSummarizedInvoicePdf = useCallback(async (row) => {
    setLoadingInvoicePdf(true);
    try {
      const data = await api.get(
        "summarized_invoice",
        {
          invoice_id: row.idFatura,
          raw_pdf: "true",
          client_id: client.client.id,
        },
        { "Content-Type": "application/pdf" },
        true
      );
      const fileURL = URL.createObjectURL(await data.blob());
      const pdfWindow = window.open(fileURL, "_blank");

      setTimeout(() => {
        if (pdfWindow?.document) {
          pdfWindow.document.title = "Fatura.pdf";
        }
      }, 750);
    } catch (error) {
      const stringError = error.message;

      if (stringError.includes("detail")) {
        const splitArray = stringError.split("detail:");
        const detailText = splitArray[1].split(",")[0].trim();
        return detailText
          ? notifyError(detailText)
          : notifyError("Falha ao buscar PDF da fatura");
      }
      const splitArray = stringError.split(",");
      const basicError = splitArray[0].trim();
      return basicError
        ? notifyError(basicError)
        : notifyError("Falha ao buscar PDF da fatura");
    } finally {
      setLoadingInvoicePdf(false);
    }
  }, []);

  async function sendSms(phoneValue, faturaDetails, codigoBarras) {
    setLoadingFature(true);

    try {
      const lastCard = client.client.numeroCartaoTruncado.slice(-4);
      if (!codigoBarras) {
        throw new Error("Falha ao enviar SMS, não possui linha digitável");
      }

      await api.post("send_sms_barCode", {
        descProd: client.product.desc_prod,
        numberCard: lastCard,
        expiryDate: faturaDetails?.dataVencimento,
        totalValue: faturaDetails?.valorTotal,
        linhaDigitavel: codigoBarras,
        clientId: client.client.id,
        productCode: client.product.codigoProduto,
        phone: phoneValue.replace(/[^\d]/g, ""),
        companyId,
        invoiceId: faturaDetails?.idFatura,
      });
      notifySucces(`Sucesso! Sms enviado para ${phoneValue}`);
      closeModalSendFaturas();
      if (refreshClientV2) await refreshClientV2();
    } catch (error) {
      notifyError(`Falha ao enviar sms para ${phoneValue}`);
      closeModalSendFaturas();
    }
  }

  const handleSendSMSFatura = useCallback(
    (valueEmail) => {
      const { phone, customPhone, sendToUnregisteredPhone } = valueEmail;

      const formattedPhone = sendToUnregisteredPhone ? customPhone : phone;

      if (typeSendFature === "fatura") {
        sendSms(formattedPhone, selectedInvoice, codBarras);
      } else {
        alert("FATURA E BOLETO");
      }
    },
    [selectedInvoice, typeSendFature, codBarras]
  );

  const currentInvoice = invoices.find((item) => item.status === "ATUAL");
  const due_date = faturaSelected?.dataVencimento?.split("/");
  const formatted_due_date =
    due_date && `${due_date[2]}-${due_date[1]}-${due_date[0]}`;

  return (
    <Style.WrapperFaturaV2 ref={observe}>
      <div className="fatura-v2__header">
        <div className="fatura-v2__header--left">
          <p>Faturas</p>
        </div>
        <div className="fatura-v2__header--right">
          {rangeDate ? (
            <ConfigProvider locale={datePickerLocale}>
              <RangePicker
                defaultValue={[moment(lastYear), moment(today)]}
                format="DD/MM/YYYY"
                onChange={changeRangeFatura}
              />
              <button
                type="button"
                className="filter close"
                onClick={() => setRangeDate(false)}
              >
                <AiOutlineClose />
              </button>
            </ConfigProvider>
          ) : (
            <button
              type="button"
              className="filter"
              onClick={() => setRangeDate(true)}
            >
              <FaFilter />
            </button>
          )}

          <Dropdown overlay={menuInsurance} trigger={["click"]}>
            <button
              type="button"
              className="btn-configs"
              data-testid="faturav2-acoes"
            >
              <BiMenu />
              <p>Ações</p>
            </button>
          </Dropdown>
        </div>
      </div>

      {loadingInvoice ? (
        <div className="faturas-v2__loading">
          <LoadingElevaty />
        </div>
      ) : (
        <>
          <div className="faturas-v2__table--calendar">
            {carouselInvoices ? (
              <Slider {...settings}>
                {carouselInvoices.map((item) => (
                  <div
                    className={`faturas-v2__table--calendar--item ${
                      item.idFatura === faturaSelected?.idFatura ? "active" : ""
                    }`}
                    key={item.idFatura}
                    onClick={() => handleSelectFatura(item)}
                  >
                    {item.idFatura === faturaSelected?.idFatura ? (
                      <FileIcon color="#5188F4" />
                    ) : (
                      <FileIcon
                        color={
                          item.statusPagamento === "INTEGRAL"
                            ? "#309200"
                            : item.statusPagamento === "PARCELADO" ||
                              item.statusPagamento === "MINIMO" ||
                              item.statusPagamento === "ABAIXO_DO_MINIMO"
                            ? "#FF4D4F"
                            : "#8C8C8C"
                        }
                      />
                    )}

                    <p>
                      <strong>
                        {item.MesVencimento} {item.anoVencimento}
                      </strong>
                    </p>
                    <p>{item.valorTotal}</p>

                    <div className="arrow-down">
                      <FaSortDown />
                    </div>
                  </div>
                ))}
              </Slider>
            ) : (
              ""
            )}
          </div>

          {faturaSelected ? (
            <div className="fatura-v2__last-ticket">
              <div className="fatura-v2__last-ticket--left">
                <p>
                  Venc. {faturaSelected?.DataVencimentoOnly}{" "}
                  {faturaSelected?.MesVencimento}
                </p>
                {infosFullFatura?.melhorDiaCompra ? (
                  <p>Melhor dia de compra {infosFullFatura?.melhorDiaCompra}</p>
                ) : (
                  ""
                )}
              </div>

              <div className="fatura-v2__last-ticket--center">
                <p>
                  <strong>{faturaSelected?.valorTotal}</strong>
                </p>
                {faturaSelected.valorMinimo ? (
                  <p>Min: {faturaSelected?.valorMinimo}</p>
                ) : (
                  ""
                )}
              </div>

              {faturaSelected?.idFatura.indexOf("future") !== -1 ? null : (
                <div className="fatura-v2__last-ticket--right">
                  <div className="item-send">
                    <DuplicatedInvoicePDFModal
                      invoiceId={faturaSelected.idFatura}
                      dueDate={formatted_due_date}
                    />
                    {faturaSelected?.status === "ATUAL" && (
                      <Popover
                        placement="bottom"
                        content="Enviar linha digitável"
                      >
                        <MdOutlineSend
                          data-testid="faturav2-enviar-linha-digitavel"
                          onClick={() => getClosedInvoice(faturaSelected)}
                        />
                      </Popover>
                    )}
                    <Can permission="permission_view_summarized_invoices">
                      {faturaSelected?.status === "ATUAL" && (
                        <Popover
                          placement="bottom"
                          content="Baixar fatura resumida"
                        >
                          {loadingInvoicePdf ? (
                            <LoadingOutlined />
                          ) : (
                            <AiOutlineFilePdf
                              data-testid="faturav2-baixar-fatura-resumida"
                              onClick={() =>
                                showSummarizedInvoicePdf(faturaSelected)
                              }
                            />
                          )}
                        </Popover>
                      )}
                    </Can>
                  </div>
                  <Style.GenerateInvoiceButton>
                    <button
                      type="button"
                      onClick={() =>
                        onGetInvoicePdf(
                          faturaSelected?.idFatura,
                          formatted_due_date,
                          client?.client?.cpf
                        )
                      }
                      disabled={loadingInvoiceIdPdf}
                    >
                      {loadingInvoiceIdPdf ? (
                        <span>
                          <LoadingOutlined />
                        </span>
                      ) : (
                        <span>
                          <FilePdfOutlined className="download-invoices" />
                          <p>Gerar</p>
                        </span>
                      )}
                    </button>
                  </Style.GenerateInvoiceButton>
                </div>
              )}
            </div>
          ) : null}

          {loadingTable ? (
            <div className="faturas-v2__loading">
              <LoadingElevaty />
            </div>
          ) : (
            <div className="fatura-v2__table">
              <div className="fatura-v2__table--header">
                <div className="fatura-v2__table--header__data">
                  <p>Data</p>
                </div>
                <div className="fatura-v2__table--header__local">
                  <p>Local</p>
                </div>
                <div className="fatura-v2__table--header__cartao">
                  <p>Cartão truncado</p>
                </div>
                <div className="fatura-v2__table--header__real">
                  <p>Valor em Real</p>
                </div>
              </div>

              <span>
                {infosFullFatura ? (
                  <>
                    {infosFullFatura?.lancamentos
                      ?.slice(0, 8)
                      ?.map((item, index) => (
                        <div
                          className={`fatura-v2__table--item ${item.tipo} ${
                            index === 0 ? "first" : ""
                          }`}
                          key={Math.random()}
                        >
                          <div className="item-data">
                            <FaRegCalendarAlt />

                            <p>{item.dataTransacao}</p>
                          </div>
                          <div className="item-info">
                            {item.tipo === "PAGAMENTO" ? (
                              <RiMoneyDollarCircleLine />
                            ) : (
                              ""
                            )}
                            {item.tipo === "VENDA" ? <FaRegBuilding /> : ""}
                            {item.tipo === "AJUSTE" ? <FiAlertTriangle /> : ""}
                            <p>{item.descricaoLancamento}</p>
                          </div>
                          <div className="item-cartao-truncado">
                            {item.numeroCartaoTruncado && (
                              <>
                                <CiCreditCard1 fontSize={16} />
                                {item.numeroCartaoTruncado}
                              </>
                            )}
                          </div>
                          <div className="item-dinheiro">
                            <p>{item.valor}</p>
                          </div>
                        </div>
                      ))}
                  </>
                ) : (
                  ""
                )}
              </span>

              <div className="fatura-v2__table--footer">
                <div className="invoices-modal">
                  {infosFullFatura?.lancamentos ? (
                    <p>
                      TOTAL DE {infosFullFatura?.lancamentos.length} LANÇAMENTOS
                      EM {faturaSelected?.MesVencimento}{" "}
                      {faturaSelected?.anoVencimento}
                    </p>
                  ) : null}

                  {infosFullFatura?.lancamentos.length > 8 ? (
                    <button
                      type="button"
                      onClick={() => setIsModalLancamentosOpen(true)}
                    >
                      <FiEye />
                      <p>Ver todos os lançamentos</p>
                    </button>
                  ) : null}
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {/* Modal Alterar data de vencimento */}
      <ModalChangeInvoiceDueDate
        open={isChangeInvoiceDueDateVisible}
        dateCiclos={dateCiclos}
        cicloValue={cicloValue}
        closeModal={() => {
          setIsChangeInvoiceDueDateVisible(false);
        }}
        reloadAllInvoices={handleReloadInvoices}
      />

      {/* Modal simular parcelamento da fatura */}
      <Modal
        title="Parcelamento de fatura"
        open={isModalInstallmentSimulationVisible}
        onCancel={setIsModalInstallmentSimulationVisibility}
        width="80%"
        destroyOnClose
      >
        <InvoiceInstallmentSimulatorFlow
          invoices={invoices}
          onClose={setIsModalInstallmentSimulationVisibility}
          currentInvoice={currentInvoice}
        />
      </Modal>

      {/* Modal Simular parcelamento de saldo devedor */}
      <Modal
        title="Parcelamento de saldo devedor"
        open={isModalDebitBalanceVisible}
        onCancel={toggleModalDebitBalanceVisibility}
        width="80%"
        destroyOnClose
      >
        <InvoiceInstallmentSimulatorFlow
          invoices={invoices}
          onClose={toggleModalDebitBalanceVisibility}
          devedorTotal
        />
      </Modal>

      {/* Visualizar parcelamento da fatura / saldo devedor */}
      <InstallmentsViewModal
        visible={isModalInstallmentsViewVisible}
        key={isModalInstallmentsViewVisible} // Force re-render (clean state) on state transition.
        onCloseClick={setIsModalInstallmentsViewVisibility}
      />

      {/* Modal enviar fatura */}
      <Modal
        title="Enviar"
        visible={isModalFaturaOpen}
        onCancel={closeModalSendFaturas}
        width={572}
      >
        <Style.ModalFaturaSend>
          {loadingFature ? (
            <div className="modal-fatura__loading">
              <LoadingElevaty />
            </div>
          ) : (
            <>
              <div className="item-select__user">
                <p className="title">Cliente:</p>

                <div className="item-select__options">
                  <Style.DocButton
                    selected={typeFature === "email"}
                    onClick={() => {
                      setTypeFature("email");
                      setValueEmailDownload("");
                      setDisabledInput(false);
                      setDisabledInputEmail(false);
                    }}
                  >
                    <p>E-mail</p>
                  </Style.DocButton>
                  <Style.DocButton
                    selected={typeFature === "sms"}
                    onClick={() => {
                      setTypeFature("sms");
                      setValueFormInputSMS("");
                      setDisabledInputSelectSMS(false);
                      setDisabledInputSMS(false);
                    }}
                  >
                    <p>SMS</p>
                  </Style.DocButton>
                </div>
              </div>

              <div className="item-select__user">
                <div className="input-search">
                  {typeFature === "email" ? (
                    <Formik
                      initialValues={{
                        email: client?.client?.email,
                        sendToUnregisteredMail: false,
                        customEmail: "",
                      }}
                      validationSchema={Yup.object({
                        email: Yup.string()
                          .email("Deve ser um e-mail válido")
                          .nullable(),
                        customEmail: Yup.string().email(
                          "Deve ser um e-mail válido"
                        ),
                        sendToUnregisteredMail: Yup.boolean(),
                      }).test({
                        name: "has-email",
                        test: (value, ctx) => {
                          if (
                            value.sendToUnregisteredMail &&
                            !value.customEmail
                          ) {
                            return ctx.createError({
                              path: "email",
                              message: "Campo Obrigatório",
                            });
                          }

                          if (!value.sendToUnregisteredMail && !value.email) {
                            return ctx.createError({
                              path: "customEmail",
                              message: "Campo Obrigatório",
                            });
                          }
                        },
                      })}
                      onSubmit={handleSendEmailFatura}
                    >
                      {({ setFieldValue, values }) => (
                        <Form>
                          <div className="item-input">
                            <Field name="email">
                              {({ field, meta }) => (
                                <>
                                  <p>Selecione o email: </p>
                                  <Select
                                    value={field?.value || "0"}
                                    disabled={disabledInput}
                                    className={
                                      meta.touched && meta.error
                                        ? "error-id"
                                        : null
                                    }
                                    onChange={(e) =>
                                      handleSelectMail(e, setFieldValue)
                                    }
                                  >
                                    <Option value="0">Selecione</Option>
                                    <Option
                                      value={`${client?.client?.email}`}
                                    >{`${client?.client?.email}`}</Option>
                                  </Select>
                                </>
                              )}
                            </Field>
                          </div>
                          {permissions &&
                            permissions.includes(
                              "sending_unregistered_contacts"
                            ) && (
                              <div className="item-input">
                                <Field name="sendToUnregisteredMail">
                                  {({ field }) => (
                                    <Checkbox
                                      checked={field?.value ?? false}
                                      onChange={(e) =>
                                        handleChangeSendToUnregisteredMail(
                                          e.target.checked,
                                          setFieldValue
                                        )
                                      }
                                    >
                                      Enviar para outro email
                                    </Checkbox>
                                  )}
                                </Field>
                              </div>
                            )}
                          {permissions &&
                            permissions.includes(
                              "sending_unregistered_contacts"
                            ) &&
                            values.sendToUnregisteredMail && (
                              <div className="item-input">
                                <p>Digite o Email</p>
                                <Field name="customEmail">
                                  {({ field, meta }) => (
                                    <input
                                      type="text"
                                      className={
                                        meta.touched && meta.error
                                          ? "error-id"
                                          : null
                                      }
                                      placeholder={
                                        typeFature === "email"
                                          ? "Digite o e-mail que será enviado"
                                          : "Selecione ou digite um telefone de contato"
                                      }
                                      {...field}
                                      disabled={disabledInputEmail}
                                      value={valueEmailDownload}
                                      onChange={(e) =>
                                        handleChangeModalEmailInput(
                                          e,
                                          setFieldValue
                                        )
                                      }
                                    />
                                  )}
                                </Field>
                              </div>
                            )}

                          <ErrorMessage
                            name="email"
                            component="div"
                            className="error-message"
                          />
                          <ErrorMessage
                            name="customEmail"
                            component="div"
                            className="error-message"
                          />

                          <div className="item-submit">
                            <button type="submit">
                              <MdOutlineSend /> <p>Enviar</p>
                            </button>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  ) : null}
                  {typeFature === "sms" ? (
                    <Formik
                      key={false}
                      initialValues={{
                        phone: phones.length === 1 ? phones[0] : "",
                        sendToUnregisteredPhone: false,
                        customPhone: "",
                      }}
                      validationSchema={Yup.object({
                        phone: Yup.string().nullable(),
                        sendToUnregisteredPhone: Yup.boolean(),
                        customPhone: Yup.string(),
                      }).test({
                        name: "has-phone",
                        test: (values, ctx) => {
                          if (
                            !values.sendToUnregisteredPhone &&
                            !values.phone
                          ) {
                            return ctx.createError({
                              path: "phone",
                              message: "Insira um número válido",
                            });
                          }

                          if (
                            !values.sendToUnregisteredPhone &&
                            values.phone &&
                            values.phone.length < 14
                          ) {
                            return ctx.createError({
                              path: "phone",
                              message: "Número inválido",
                            });
                          }

                          if (
                            values.sendToUnregisteredPhone &&
                            !values.customPhone
                          ) {
                            return ctx.createError({
                              path: "customPhone",
                              message: "Insira um número válido",
                            });
                          }

                          if (
                            values.sendToUnregisteredPhone &&
                            values.customPhone &&
                            values.customPhone.length < 14
                          ) {
                            return ctx.createError({
                              path: "customPhone",
                              message: "Número inválido",
                            });
                          }
                        },
                      })}
                      onSubmit={handleSendSMSFatura}
                    >
                      {({ setFieldValue, values }) => (
                        <Form>
                          <div className="item-input">
                            <Field name="phone">
                              {({ field, meta }) => (
                                <>
                                  <p>Selecione o número: </p>
                                  <Select
                                    value={field?.value || "0"}
                                    disabled={disabledInputSelectSMS}
                                    className={
                                      meta.touched && meta.error
                                        ? "error-id"
                                        : null
                                    }
                                    onChange={(e) =>
                                      handleSelectSMS(e, setFieldValue)
                                    }
                                  >
                                    <Option value="0">Selecione</Option>
                                    {phones.map((_phone) => (
                                      <Option key={_phone} value={_phone}>
                                        {_phone}
                                      </Option>
                                    ))}
                                  </Select>
                                </>
                              )}
                            </Field>
                          </div>
                          {permissions &&
                            permissions.includes(
                              "sending_unregistered_contacts"
                            ) && (
                              <div className="item-input">
                                <Field name="sendToUnregisteredPhone">
                                  {({ field }) => (
                                    <Checkbox
                                      checked={field?.value ?? false}
                                      onChange={(e) =>
                                        handleChangeSendToUnregisteredSMS(
                                          e.target.checked,
                                          setFieldValue
                                        )
                                      }
                                    >
                                      Enviar para outro número
                                    </Checkbox>
                                  )}
                                </Field>
                              </div>
                            )}

                          {permissions &&
                            permissions.includes(
                              "sending_unregistered_contacts"
                            ) &&
                            values.sendToUnregisteredPhone && (
                              <div className="item-input">
                                <p>Digite o número</p>
                                <Field name="customPhone">
                                  {({ field, meta }) => (
                                    <ReactInputMask
                                      type="text"
                                      className={
                                        meta.touched && meta.error
                                          ? "error-id"
                                          : null
                                      }
                                      placeholder={
                                        typeFature === "email"
                                          ? "Digite o e-mail que será enviado"
                                          : "Selecione ou digite um telefone de contato"
                                      }
                                      mask="(99) 99999-9999"
                                      maskChar=""
                                      disabled={disabledInputSMS}
                                      {...field}
                                      onChange={(e) =>
                                        handleChangeModalSMSlInput(
                                          e,
                                          setFieldValue
                                        )
                                      }
                                      value={valueFormInputSMS}
                                    />
                                  )}
                                </Field>
                              </div>
                            )}

                          <ErrorMessage
                            name="phone"
                            component="div"
                            className="error-message"
                          />
                          <ErrorMessage
                            name="customPhone"
                            component="div"
                            className="error-message"
                          />

                          <div className="item-submit">
                            <button type="submit">
                              <MdOutlineSend /> <p>Enviar</p>
                            </button>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  ) : null}
                </div>
              </div>
            </>
          )}
        </Style.ModalFaturaSend>
      </Modal>

      <ModalListAllLaunches
        faturaSelected={faturaSelected}
        infosFullFatura={infosFullFatura}
        isModalLancamentosOpen={isModalLancamentosOpen}
        setIsModalLancamentosOpen={() => setIsModalLancamentosOpen(false)}
      />

      {/* Modal Histórico de faturas */}
      <ModalHistoricoFaturas
        isOpen={modalHistoricoFaturas}
        onClose={setModalHistoricoFaturas}
      />

      <ModalBlockedPopUp onClose={handleShowPopUpModal} visible={modalPopUp} />

      <AntecipateSalesModal
        onClose={() => setOpenAntecipateSalesModal(false)}
        visible={openAntecipateSalesModal}
        forceUpdate={forceUpdateScreen}
        handleForceUpdate={handleUpdateScreen}
      />
    </Style.WrapperFaturaV2>
  );
}

export default memo(FaturaV2);
